import { proxy } from 'valtio'
import { derive, devtools } from 'valtio/utils'
import { GlobalSortDirectionEnum } from '../../../../shared/types/GlobalSortDirectionEnum'
import { type ApiCallType } from '../../../../shared/types/ApiCallType'
import { DEFAULT_LIMIT } from '../../../../shared/utils/apiUtils'
import { type GlobalDataExportStatus } from '../../../../shared/types/GlobalDataExportStatus'

export enum DataExportsTableColumnsEnum {
  Id = 'id',
  Filters = 'filters',
  FileCount = 'fileCount',
  Type = 'type',
  Status = 'status',
}

export interface Pagination {
  totalCount: number
  limit: number
  offset: number
}

export interface UserDataExport {
  id: number
  status: GlobalDataExportStatus
  type: string
  filters: string
  fileCount: number
  files: any
}

export interface UserDataExportFile {
  id: number
  signedUrl: string
}

export interface Filters {
  offset: number
  sortColumn: DataExportsTableColumnsEnum
  sortDirection: GlobalSortDirectionEnum
}

export interface DataExportProxyType {
  apiCall: ApiCallType
  filters: Filters
  dataExports: UserDataExport[]
  currentPage: number
  currentUserDataExport: UserDataExport | null
  currentUserDataExportFiles: UserDataExportFile[] | null
  pagination: Pagination
  hasMore: boolean
}

const initialValues = {
  apiCall: {
    error: null,
    loading: false
  },
  currentPage: 1,
  currentUserDataExport: null,
  currentUserDataExportFiles: [],
  dataExports: [],
  filters: {
    offset: 0,
    search: '',
    sortColumn: DataExportsTableColumnsEnum.Id,
    sortDirection: GlobalSortDirectionEnum.Descending
  },
  pagination: {
    limit: DEFAULT_LIMIT,
    offset: 0,
    totalCount: 0
  }
}

const baseProxy = proxy(initialValues)

export const dataExportsProxy = derive({
  hasMore: get => {
    const { dataExports, pagination } = get(baseProxy)
    const totalCount = pagination?.totalCount ?? 0
    return dataExports?.length < totalCount
  }
}, { proxy: baseProxy }) as DataExportProxyType

devtools(dataExportsProxy, { name: 'dataExportsProxy' })
